import React from 'react'
import { Navigate } from 'react-router-dom'

function ResetLoginPage() {
  React.useEffect(() => {
    localStorage.removeItem('cbms_token')
  }, [])

  return <Navigate to="/entry" replace />
}

export default ResetLoginPage